import React, { useState, useEffect, useRef } from "react";
import { clsx } from "clsx";
import {useNavigationParse} from "@arctheme-hooks/useNavigationParse";
import {Collapsible} from "@arctheme-components/elements/Collapsible/Collapsible";

export const Drilldown = ({ settings, isOpen, megamenuBlock}) => {
    const linksStyle = 'h4';

    return (
        <>
            {isOpen && megamenuBlock.links?.length > 0 && (
                <ul className="w-full pt-[12px] flex flex-col">
                    {megamenuBlock.links.map((subLink, subIndex) => {
                        const titleData = useNavigationParse(subLink.title);
                        return (
                            <li
                                key={subIndex}
                                className="mobile-menu-sub-item py-[12px] last:pt-[12px] last:py-0"
                            >
                                {subLink.links?.length <= 0 && (
                                    <a
                                        href={subLink.url}
                                        className={`${linksStyle} ${titleData.class} flex items-center gap-x-[8px]`}
                                    >
                                        <span className="underline">{titleData.text}</span>{" "}
                                        {titleData.icon && (
                                            <i className={`icon ${titleData.icon}`} />
                                        )}
                                        {subLink.links?.length > 0 && (
                                            <i className="icon icon-caret-down-thin ml-auto" />
                                        )}
                                    </a>
                                )}

                                {subLink.links?.length > 0 && (
                                    <Collapsible
                                        title={titleData.text}
                                        titleClass={`${linksStyle}`}
                                        contentClass={`${linksStyle}`}
                                        openIcon="icon-caret-down-thin"
                                        closeIcon="icon-caret-up-thin"
                                        desktopDisabled
                                    >
                                        <div className="grid grid-cols-2 mt-[16px] gap-y-[16px]">
                                            {subLink.links.map((subSubLink, subSubIndex) => (
                                                <a
                                                    key={subSubIndex}
                                                    href={subSubLink.url}
                                                    className=""
                                                >
                                                    {subSubLink.title}
                                                </a>
                                            ))}
                                        </div>
                                    </Collapsible>
                                )}
                            </li>
                        );
                    })}
                </ul>
            )}
        </>
    );
};

export default Drilldown;
